export const mexicanSpanishLabels = {
    planLbl: {
        plan: "Plan",
        createNewPlan: "Crear un Nuevo Plan",
        copyAnExistingPlan: "Copiar de un Plan Existente",
        addNewPlan: "Agregar un Nuevo Plan",
        selectExistingPlan: "Seleccionar un Plan Existente",
        railCarPlan: "Plan del Carro",
        deletePlanMsg: "Esta a punto de borrar el Plan",
        confirmOpr: "Desea Confirmar la Operación?",
        enterAARCarType: "Ingrese el Tipo de Carro AAR para agregarlo al Plan",
        addedCarTypes: "Tipos de Carro agregados",
        reviewNcont: "Revise y Continue",
        assistance: "Ayuda",
        assistanceMsg:
            "Si ya conoces los tipos de carro, ingresalos y da clic en agregar para registrarlos en el plan. En caso contrario, usa el boton de ayuda para encontrar tu tipo de equipo.",
        maxPlanNameLenMsg: "El Nombre del Plan es de 20 caracateres maximo",
        maxDescLenMsg: "La Descripcion del Plan es de 150 caracteres maximo",
        planNameMand: "Nombre del Plan**",
        copyOf: "Copiar de",
        description: "Descripción",
        leStatusMand: "Estatus L/E*",
        clear: "Limpiar",
        add: "Agregar",
        createPlanMsg: "Vamos a Crear un Nuevo Plan para Iniciar",
        cancelCreatNew: "Cancelar la creación del Nuevo Plan",
        planDiscardConfirmMsg:
            "El Plan que acabas de crear sera elimnado, estas seguro de eliminarlo?",
        reviewPlan: "Revisar el Plan",
        backtoEdit: "Regresar a Editar",
        deletePlan: "Borrar Plan",
        review: "Revisar",
        good: "Correcto",
        maxCommentLenMsg: "La Comentario es de 150 caracteres maximo",
        planSuccessMsg: "creado exitosamente.",
        equipmentType: "Tipo de Equipo",
        commodity: "Producto",
        leStatus: "Estatus L/E",
        planName: "Nombre del Plan",
        origin: "Origen",
        destination: "Destino",
        quantity: "Cantidad",
        gUnit: "Unidad",
        targetETAWindow: "Ventana de ETA Objetivo",
        hazardous: "Peligroso",
        addToPlan: "Agregar al Plan",
        cancel: "Cancelar",
        apply: "Aplicar",
        addedCommodity: "Detalles del producto agregado",
        planType: "Tipo de Plan",
        equipment: "Equipo",
        calendarView: "Vista de Calendario",
    },

    managePlanFilterOptions: {
        PLAN_TYPE: {
            label: "Tipo de Plan",
            name: "PlanType",
        },
    },

    carOrderLbl: {
        carOverview: "DETALLE DEL PEDIDO",
        patternInfo: "INFORMACION DEL PATRON",
        patternId: "ID de Patrón",
        roadId: "ID de FFCC",
        station: "Estación",
        track: "Vía",
        comment: "Comentario",
        commodity: "Producto",
        railTracking: "Numero de Via",
        carType: "Tipo de Carro Genérico",
        carKind: "Tipo de Carro Específico",
        orderedBy: "Ordenado Por",
        submitDate: "Fecha Solicitada",
        alternativeCarType: "Tipo de Carro Genérico Alternativo",
        alternativeKind: "Tipo de Carro Específico Alternativo",
        newCarOrder: "Nuevo Pedido de Carro",
        selectPattern: "1. Seleccione un Patrón",
        wanted: "Solicitados",
        assigned: "Asignados",
        placed: "Situados",
        carOrder: "Pedido de Carro",
        placeTheOrder: "CREAR SU PEDIDO",
        orderDailyQuality: "2. Solicite sus Carros por Día",
        maximumDailyCars: "Máximo de Carros Diarios",
        minimumDays: "Días Mínimos",
        maximumDays: "Días Máximos",
        serviceDays: "Días de Servicio",
        weekTotals: "Totales por Semana",
        confirmOrder: "Confirmar Orden",
        confirmOrderMessage:
            "Está por crear una nuevo pedido. ¿Deséa confirmar la operación?",
        placeCarOrderSuccessMessage: "Tu Pedido ha Sido Creado.",
        placeCarOrderFailureMessage: "No se puede procesar el pedido.",
        order: "Pedido",
        dateWanted: "Fecha Solicitada",
        pattern: "Patrón",
        days: "Días",
        dailyCars: "Carros Diarios",
    },

    weekDays: ["DOM", "LUN", "MAR", "MIE", "JUE", "VIE", "SAB"],

    months: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
    ],

    monthsInitials: [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
    ],

    common: {
        cancel: "Cancelar",
        confirm: "Confirmar",
        apply: "Aplicar",
        edit: "Editar",
        details: "Detalles",
        delete: "Borrar",
        create: "Crear",
        selectPlan: "Seleccione Plan",
        front: "Frente",
        back: "Atrás",
        andOr: "y/o",
        managePlan: "Administrar Plan",
        managePlans: "Administrar Planes",
        addNewPlan: "Agregar un Nuevo Plan",
        default: "Default",
        plan: "Plan",
        railCarStatus: "Estado del Carro",
        onHand: "En Industria",
        inBound: "En Transito",
        planned: "Planeados",
        projected: "Proyectados",
        summaryMetrics: "Resumen y Métricas",
        lastUpdatedInfo: "Último Reporte",
        modifiedBy: "Modificado por",
        carOrder: "Pedido de Carro",
        currentWeek: "*Semana Actual",
        download: "Descargar",
        updatePlan: "Actualizar Plan",
        save: "Guardar",
        previous30Days: "30 Días Anteriores",
        next30Days: "30 Días Posteriores",
        load: "Cargado",
        empty: "Vacío",
        all: "Cargado/Vacío",
        newOrder: "Nuevo Pedido",
        latestWantDate: "Fecha Solicitada",
        latestSubmitDate: "Solicitud Creada",
        latestOrderName: "Numero de orden",
        filter: "Filtro",
        reset: "Reiniciar",
        open: "Abierto",
        completed: "Completado",
        canceled: "Cancelado",
        closed: "Cerrado",
        complete: "Completa",
        inputRange: "Ingresar Rango",
        dateRange: "Rango de Fechas",
        dateRangePicker: "Seleccione Rango de Fechas ",
        datePicker: "Seleccione Fechas",
        week: "Semana",
        metric: "Métrica",
        maximum31Days: "31 días máximo",
        next: "SIGUIENTE",
        clear: "LIMPIAR",
        dashboard: "Tablero",
        requiredFields: "Campos Requeridos",
        sortBy: "Ordenar por",
        status: "Estatus",
        clearAll: "Limpiar todo",
        totalEquipmentHeader: "Total de Equipos",
        lastUpdated: "Última Actualización",
        at: "En",
        search: "Buscar",
        noRecordsFound: "No hay registros",
        searchOnAnyField: "Busqueda por cualquier campo",
        loadingData: "Cargando…",
        logout: "Salir",
        selectedEquipment: "Equipo seleccionado",
        train: "Tren",
        yes: "Sí",
        no: "No",
        loaded: "Cargado",
        name: "Nombre",
        loadStatus: "Estatus de Cargado",
        date: "Fecha",
        activeTrains: "Trenes Activos",
        noResultsFound: "No se Encontraron Resultados",
        noRailRoadError:
            "configuración está incompleta. Póngase en contacto con el soporte de Wabtec.",
        close: "Cerrar",
        continueEditing: "CONTINUER L’ÉDITION",
        type: "Tipo",
        email: "Email",
        private: "Privado",
        public: "Público",
        faq: "FAQ",
        releasenotes: "Notas de liberacion",
        noOrganizationsFound: "No se Encontraron Organizaciones",
        InvalidEmailAddress: "Dirección de correo electrónico no válida",
        DuplicateMailNotAllowed:
            "Dirección de correo electrónico duplicada no permitida",
        InvalidOrDupEmail:
            "Dirección de correo electrónico no válida o duplicada",
        Max4000Chars: "Máximo de 4000 caracteres permitidos",
        savedSuccessfully: "Guardado con éxito",
        New: "Nuevo",
        Contents: "Contenidos",
        successfullyUpdated: "actualizado correctamente.",
    },

    dashboard: {
        badOrderEqStatus: "ESTATUS DE EQUIPO MAL ORDEN",
        storageEqStatus: "ESTATUS DE EQUIPO ALMACENADO",
        badOrder: "Mal Orden",
        overweight: "Sobrepeso",
        hazmat: "Material Peligroso",
        onHold: "Detenido",
        holdMisc: "DETENIDOS",
        inventory: "Inventario",
        enroute: "En Otro FFCC",
        inbound: "En Transito",
        onHand: "En Industria",
        outbound: "Remitidos",
        enrouteDesc: "En Transito en Otro FFCC",
        inboundDesc: "En Transito Entrante",
        onHandDesc: "Equipo en Industria",
        outboundDesc: "Equipo Saliente de mi Industria",
        load: "Cargado",
        empty: "Vacío",
        netTon: "Ton Neta",
        tonnage: "Tonelaje",
        netTons: "Tons Netas",
        noEta: "Sin ETA",
        storage: "Almacenaje",
        inboundPipeline: "Flujo en Transito a  7 días",
        planName: "Nombre del Plan",
        totalCars: "Total de Carros",
        railroadDwellTime: "Tiempo de permanencia en el Ferrocarril",
        shipperDwellTime: "Tiempo de permanencia del Remitente",
        total: "Total",
        badOrderEq: "Equipo Mal Orden",
        totalEquipment: "Equipo Total",
        storageEquipment: "Equipo Almacenado",
        totalOnlineEquipment: "EQUIPO TOTAL ONLINE",
        onlineEquipStatus: "ESTATUS DE EQUIPO ONLINE",
        onTrains: "En Tren",
        onTracks: "En Via",
        totalOnline: "Total Online",
        dwellTime: "TIEMPO DE PERMANENCIA",
        lessThan24: "< 24 Horas",
        hours24to48: "24 - 48 Horas",
        greaterThan48: "> 48 Horas",
        railroadDwellInfo:
            "-Tiempo de permanencia en el Ferrocarril: Resumen del equipo inactivo que no está almacenado, en BO, en espera, por falta de cupo o actualmente situado.",
        shipperDwellInfo:
            "-Tiempo de permanencia del Remitente: Resumen del equipo inactivo que se encuentra actualmente en la Industria.",
        totalStorage: "Total Almacenaje",
        others: "Otros",
        totalNetTons: "Total Toneladas Netas",
        forecasting: "Pronóstico",
        totalCommodities: "Total de Producto",
        badOrderInfo:
            "Equipos BO (BGLT o BHVY). Equipo que necesita reparación.",
        overWeightInfo:
            "Equipos con sobrepeso. Equipo cuyo peso total excede la capacidad de la vía o de la unidad.",
        inventoryInfo:
            "Resumen de la cantidad de equipos desglosados por tipo de envío que se pueden filtrar por cargados o vacíos.",
        netTonsInfo:
            "Resumen de toneladas netas por producto que se pueden filtrar por tipo de envío individual.",
        hazmatInfo: "Equipo que contiene producto peligroso.",
        storageInfo:
            "Equipo que se encuentra en estado de Almacenaje (STEA, STEX, STPL, STSE, STSU o STUN). Equipo que se solicita detener y está sujeto a cargos por almacenaje.",
        constructivelyPlacedInfo:
            "Equipos en estado de Falta de Cupo (PCON). Equipos que no pueden ser situados para su carga o descarga, y podría estar sujeto a cargos por Demora.",
        onHoldInfo:
            "Equipo en estado de espera (HMIS). Equipo que se ha solicitado que sea detenido por el Ferrocarril. *Esto no es una detencion de embargo.",
        placedFacilityInfo:
            "Equipo en condicion de situado (PACT) en la Industria.",
        releasedFacilityInfo: "Equipo Liberado (RLOD o RMTY) en la Industria.",
        placedAtFacility: "Situado en Industria",
        releasedAtFacility: "Liberado de Industria",
        noEtaForecasting:
            "Sin ETA: Equipo que actualmente no tiene una ETA. Pronóstico: Resumen de los planes de pronóstico actuales para los próximos 7 días.",
        enRouteToMyRailroad: "En tránsito en otro FFCC",
        inBoundToMyFacility: "En tránsito",
        onHandAtMyFacility: "En mi industria",
        outboundFromMyFacility: "Equipo remitido",
        interModalLoad: "Intermodal Cargado",
        interModalEmpty: "Intermodal Vacio",
    },

    imagePath: {
        A: "/images/RailCars/Box_car_",
        B: "/images/RailCars/Box_car_",
        C: "/images/RailCars/Hopper_",
        H: "/images/RailCars/Hopper_",
        K: "/images/RailCars/Hopper_",
        E: "/images/RailCars/Gondola_",
        G: "/images/RailCars/Gondola_",
        U: "/images/RailCars/Gondola_",
        J: "/images/RailCars/Gondola_",
        F: "/images/RailCars/Flatcar_",
        V: "/images/RailCars/Flatcar_",
        I: "/images/RailCars/Intermodal_",
        P: "/images/RailCars/Intermodal_",
        R: "/images/RailCars/Refrigerator_",
        S: "/images/RailCars/Stack_car_",
        T: "/images/RailCars/Tank_car_",
        Z: "/images/RailCars/Trailer_",
    },

    errorLabel: {
        overCapacity: "Excedido",
    },

    visibilityLbl: {
        visibility: "Visibilidad",
        totalOnlineEquipment: "Total de Equipos: ",
        lastUpdated: "Última Actualización: ",
        actionPanel: "PANEL DE ACCIONES",
        action: "ACCIÓN",
        listedEquipment: "Equipo Enlistado: ",
        spot: "Posicion",
        station: "Estación",
        stations: "Estaciones",
        track: "Vía",
        equipId: "ID de Equipo",
        shipmentType: "Tipo de Embarque",
        comment: "Comentario",
        wayBillNumber: "Número de Guía",
        equipmentKind: "Tipo Específico de Equipo",
        equipmentType: "Tipo Genérico de Equipo",
        carStatus: "L/E",
        commodity: "Producto",
        lastMovType: "Tipo de Ultimo Movimiento",
        createBill: "Documentar",
        badOrder: "Mal Orden",
        hold: "Detenido",
        intraPlant: "Intraplanta",
        move: "Mover",
        outOfStorage: "Fuera de Almacenaje",
        place: "Situar",
        reject: "Rechazar",
        releaseEmpty: "Liberar de Vacío",
        releaseInSameStatus: "Liberar en el Mismo Estado",
        releaseReload: "Liberar & Recargar",
        turn: "Girar",
        weigh: "Peso",
        downloadCSV: "Exportar a CSV",
        clearActionPanelList: "Limpiar Listado de Panel de Acción",
        rejectReason: "Razón de Rechazo",
        inventory: "Inventario",
        requestDateMand: "Fecha Solicitada *",
        requestTimeMand: "Hora Solicitada *",
        spotStartfrom: "Posicion (Inicia desde)",
        other: "Otros",
        otherReason: "Otra Razón",
        Comment: "Comentario",
        columnsCustomizations: "Personalizar Columnas",
        ebolFailureMessage:
            "Hay un problema con su perfil de eBOL. Póngase en contacto con su administrador",
        actuallyPlaced: "Situado",
        constructivelyPlaced: "Falta de Cupo",
        released: "Liberado",
        ownerDetails: "Detalles del Propietario",
        actionResult: "Resultado de la Accion",
        actionProcessedSuccessfully: "Procesado con éxito",
        inTransit: "En Tránsito",
        arrivedAtFD: "Llegada al destino final",
        tripComplete: "Viaje Completo",
        warning: "Aviso",
        resequence: "Resecuencia",
        resequenceDoneMsg:
            "La solicitud de resecuenciación se ha completado con éxito.",
        resequenceFailedMsg:
            "La solicitud de resecuenciación no se pudo procesar.",
        resequenceWarning:
            "Está a punto de cerrar un cuadro de diálogo sin guardar. Todos los cambios se perderán. ¿Estás seguro de que quieres cerrar sin ahorrar?",
        unsavedChanges: "Cambios no guardados",
        loadingData: "Cargando datos",
        loadingFailed: "Carga fallida",
        equipmentSearch: "Búsqueda de equipos",
        equipmentMultiSearch: "Búsqueda múltiple de equipos",
        multiSearchSubtext1:
            "Pegue o escriba el texto en el área de abajo y luego haga clic en Buscar equipo",
        multiSearchSubtext2:
            "*RVP acepta datos de Excel, campos separados por comas y texto sin formato.",
        multiSearchSubtext3:
            "La pantalla acepta hasta 150 equipos para la búsqueda.",
        equiment: "Equipos",
        equipmentFormat:
            "Introduzca los ID de los equipos, por ejemplo, ABCD 123456, EFG 000123",
        searchEquipment: "Buscar equipo",
        notFound: "No encontrado",
        invalidEquipmentFormatMsg:
            "El formato de datos que ha introducido no es válido. Corrija el formato e inténtelo de nuevo (por ejemplo, ABCD 123456, EFG 000123).",
        notFoundRailcarsMsg:
            "Estos vagones no se encontraron en el sistema. Edite los errores y haga clic en el botón 'Buscar equipo' para continuar.",
        equipmentFound: "Equipos encontrados",
        originAndDestination: "Origen y destino",
        parties: "Partes de la carta de porte",
        dateAndMovements: "Fechas y movimientos",
        equipmentAndCommodity: "Equipos y productos básicos",
        equipmentIndicators: "Indicadores de equipo",
        etaDataNotAvailable: "Datos de ETA no disponibles",
        etiDataNotAvailable: "Datos de ETI no disponibles",
        shippedDataNotAvailable: "Datos de fecha de envío no disponibles",
        lmDataNotAvailable:
            "Datos de la fecha del último movimiento no disponibles",
        hasComments: "Comentarios disponibles",
        ETI: "Tiempo estimado de intercambio",
        ETA: "Tiempo estimado de llegada",
        noETA: "Sin ETA",
        exception: "Excepción",
    },

    actionMenuOne: ["Documentar"],

    actionMenuTwo: [
        "Detenido",
        "Situar",
        "Rechazar",
        "Girar",
        "Peso",
        "Fuera de Almacenaje",
        "Intraplanta",
        "Mover",
        "Liberar de Vacío",
        "Liberar & Recargar",
        "Liberar en el Mismo Estado",
        "Mal Orden",
    ],

    actionMenuThree: ["Descargar CSV", "Limpiar Listado de Panel de Acción"],

    calendar: {
        clear: "Limpiar",
    },

    shipmentTypes: {
        1: "En Otro FFCC",
        2: "En Transito",
        3: "En Industria",
        4: "Remitidos",
        5: "Remitidos",
    },

    shipmentTypeActionMapper: {
        1: ["Detenido", "Situar", "Girar", "Peso"],
        2: [
            "Detenido",
            "Situar",
            "Rechazar",
            "Girar",
            "Peso",
            "Mal Orden",
            "Fuera de Almacenaje",
            "Documentar",
        ],
        3: [
            "Detenido",
            "Situar",
            "Rechazar",
            "Girar",
            "Peso",
            "Mal Orden",
            "Fuera de Almacenaje",
            "Intraplanta",
            "Mover",
            "Liberar de Vacío",
            "Liberar en el Mismo Estado",
            "Liberar & Recargar",
            "Documentar",
        ],
        4: [
            "Out of Storage",
            "Liberar de Vacío",
            "Liberar en el Mismo Estado",
            "Liberar & Recargar",
            "Documentar",
        ],
        5: [
            "Liberar de Vacío",
            "Liberar en el Mismo Estado",
            "Liberar & Recargar",
            "Documentar",
        ],
    },

    shipmentTypeTrackAndSpotOperationIndicator: {
        Detenido: {
            Track: { disabled: true, required: false },
            Spot: { disabled: true, required: false },
        },
        Situar: {
            Track: { disabled: false, required: true },
            Spot: { disabled: false, required: true },
        },
        Rechazar: {
            Track: { disabled: true, required: false },
            Spot: { disabled: true, required: false },
        },
        Girar: {
            Track: { disabled: true, required: false },
            Spot: { disabled: true, required: false },
        },
        Peso: {
            Track: { disabled: true, required: false },
            Spot: { disabled: true, required: false },
        },
        "Mal Orden": {
            Track: { disabled: true, required: false },
            Spot: { disabled: true, required: false },
        },

        "Fuera de Almacenaje": {
            Track: { disabled: true, required: false },
            Spot: { disabled: true, required: false },
        },

        Intraplanta: {
            Track: { disabled: false, required: true },
            Spot: { disabled: false, required: true },
        },

        Mover: {
            Track: { disabled: false, required: true },
            Spot: { disabled: false, required: true },
        },
        "Liberar de Vacío": {
            Track: { disabled: false, required: false },
            Spot: { disabled: false, required: false },
        },

        "Liberar en el Mismo Estado": {
            Track: { disabled: false, required: false },
            Spot: { disabled: false, required: false },
        },
        "Liberar & Recargar": {
            Track: { disabled: false, required: false },
            Spot: { disabled: false, required: false },
        },
    },

    wayBillInformationLbl: {
        waybillNumber: "Número de Guía",
        waybillDate: "Fecha de Guía",
        equipmentKind: "Tipo Específico de Equipo",
        status: "Estatus",
        blockTo: "Entregar A",
        leStatus: "Estatus L/E",
        stcc: "STCC",
        billOfLading: "Numero de BOL",
        badOrderStatus: "Estado Mal Orden",
        multiCar: "Multi Carro",
        tmc: "Metodo de Transporte",
        currentStation: "Estación Actual",
        currentTrack: "Vía Actual",
        lastMoveType: "Tipo de Ultimo Movimiento",
        activityIndication: "Indicador de Actividad",
        lastMoveDateTime: "Fecha y Hora de Último Movimiento",
        wayBill: "GUÍA",
        originDestinations: "Estaciones de Origen y Destino",
        origin: "Origen",
        destination: "Destino",
        fsac: "FSAC",
        city: "Estacion",
        state: "Estado",
        country: "País",
        routing: "Ruta",
        role: "Rol",
        railRoad: "Ferrocarril",
        juntion: "Empalme",
        shipper: "Remitente",
        companyName: "Compañía",
        address: "Domicilio",
        zipCode: "C.P.",
        customers: "Clientes",
        consignee: "Consignatario",
        inCareofParty: "Encargado de la Descarga",
        equipmentDetails: "Detalles de Equipo",
        information: "Información",
        specifications: "Especificaciones",
        equipmentID: "ID de Equipo",
        aARType: "Tipo AAR",
        outsideLength: "Longitud Externa (mts, cm)",
        outsideHeight: "Altura Externa (mts, cm)",
        reclaimCode: "Código de Reclamo",
        outsideWidth: "Ancho Externo (mts, cm)",
        weightCode: "Código de Peso",
        carHireFlag: "Car Hire",
        haulage: "Arrastre Largo",
        netWeight: "Peso Neto (kg)",
        tare: "Peso Tara (kg)",
        methodCode: "Codigo de Transporte",
        eDIType: "Tipo de EDI",
        allowanceKg: "Tolerancia (kg)",
        commodity: "Producto",
        detail: "Detalle",
        description: "Descripción",
        productGroup: "Grupo de Producto",
        Weightkglbston: "Peso (kg)",
        weightType: "Tipo de Peso",
        overweightIND: "Indicador de Sobrepeso",
        ladingQTY: "Cantidad de Carga",
        unit: "Unidad",
        commodityDetail: "DETALLE DE PRODUCTO",
        hazmatDetail: "DETALLE DE MATERIAL PELIGROSO",
        placardNotation: "Codigo de Emergencia",
        personCertifyingtheShipment: "Persona Certificando el Envío",
        tIHPIH: "PIT/PIV (Peligro Inhalación Tóxica/Peligro Inhalación Venenosa)",
        ladingQty: "Cantidad de Carga",
        ladingUnit: "Unidad de Carga",
        packingGroup: "Grupo de Embalaje",
        hazmatPhoneNumber: "Teléfono 24 Hrs Material Peligroso",
        volumeWeightQty: "Cantidad de Volumen",
        volumeWeightUnit: "Unidad del Volumen",
        canadianHazmatInformation:
            "Informacion Canadiense de Material Peligroso",
        emergencyResponsePlanNumber: "Número de Plan de Emergencia",
        packingGroupCode: "Código de Grupo de Embalaje",
        HazmatNotation: "Notas de Material Peligroso",
        emergencyResponseTelephoneNumber: "Teléfono de Número de Emergencia",
        uNHazmatIdentificationInformation:
            "Identificación de Material Peligroso UN",
        uNNACode: "Código UN/NA",
        uNHazardPageNumber: "Número de Pagina de UN",
        emergencyContact: "Contacto de Emergencia",
        references: "Referencias",
        outbound: "Remitidos",
        onHand: "En Industria",
        inbound: "En Transito",
        enRoute: "En Otro FFCC",
        referenceCode: "Codigo de Referencia",
        referenceInfo: "Informacion de Referencia",
        referenceDateTime: "Fecha y Hora de Referencia",
        repeatingGroup: "Grupo de Repeticion",
        overview: "Visión General",
        hazmat: "Material Peligroso",
        tripHistory: "Historia de Viaje",
        noTripHistory: "Ningún movimiento de equipo encontrado",
        currentEvent: "Evento Actual",
        notPlanned: "No Planeado",
    },

    waybillTripHistoryColumns: {
        MOVE_TYPE: {
            headerName: "Tipo de Movimiento",
            field: "EventDescription",
        },
        MOVE_TIME: {
            headerName: "Tiempo de Movimiento",
            field: "EventDate",
        },
        MOVE_CITY: {
            headerName: "Estación de Movimiento",
            field: "EventCityState",
        },
        EVENT: {
            headerName: " Evento",
            field: "EventType",
        },
        STATION: {
            headerName: "Estación",
            field: "StationName",
        },
        PLANNED_DATE_TIME: {
            headerName: "Fecha y hora planificadas",
            field: "PlannedEventDate",
        },
        ACTUAL_DATE_TIME: {
            headerName: "Fecha y hora reales",
            field: "ActualEventDate",
        },
        VARIANCE: {
            headerName: "Varianza",
            field: "Variance",
        },
    },

    visibilityColumnGroups: {
        CURRENT_LOCATION: "Localización Actual",
        EQUIPMENT_INFO: "Informacion del Equipo",
        LAST_MOVEMENT_INFO: "Informacion del Último Movimiento",
        SHIPPED_INFO: "Informacion de Envío",
        ETA_INFO: "Información de ETA",
        PLACEMENT_INFO: "Informacion de Situado",
        WEIGHT_INFO: "Informacion de Peso",
    },

    visibilityColumns: {
        STATION: {
            headerName: "Estación",
            field: "Station",
        },
        TRACK: {
            headerName: "Vía",
            field: "Track",
        },
        TRACK_SEQ: {
            headerName: "Sec",
            field: "TrackSequence",
        },
        EQUIP_ID: {
            headerName: "Equipo",
            field: "Railcar",
        },
        SHIPMENT_TYPE: {
            headerName: "Tipo de Embarque",
            field: "ShipmentType",
        },
        BLOCK_TO: {
            headerName: "Entregar A",
            field: "BlockTo",
        },
        COMMENT: {
            headerName: "Comentario",
            field: "Cmnt",
        },
        WAYBILL_NO: {
            headerName: "Número de Guía",
            field: "WaybillNumber",
        },
        BOL_NO: {
            headerName: "Numero de BOL",
            field: "BOLNumber",
        },
        EQUIPMENT_KIND: {
            headerName: "Tipo Específico de Equipo",
            field: "Equip_Kind",
        },
        CAR_TYPE: {
            headerName: "Tipo Genérico de Equipo",
            field: "CarType",
        },
        EQUIP_KIND: {
            headerName: "Tipo Específico de Equipo",
            field: "CarKind",
        },
        LE_STATUS: {
            headerName: "L/E",
            field: "LoadEmptyStatus",
        },
        COMMODITY: {
            headerName: "Producto",
            field: "CommodityDescription",
        },
        EVENT_ROAD: {
            headerName: "Ferrocarril Actual",
            field: "EventRoad",
        },
        EVENT_CODE: {
            headerName: "Último Movimiento",
            field: "EventCode",
        },
        EVENT_DATE: {
            headerName: "Fecha de Último Movimiento",
            field: "EventDate",
        },
        EVENT_CITY_STATE: {
            headerName: "Estacion de Último Movimiento",
            field: "EventCityState",
        },
        CARRIER: {
            headerName: "Ferrocarril",
            field: "Carrier",
        },
        SHIPPED_DATE: {
            headerName: "Día Remitido",
            field: "ShippedDate",
        },
        ORIGIN_CITY: {
            headerName: "Estacion de Origen",
            field: "OriginCityState",
        },
        SHIPPER: {
            headerName: "Remitente",
            field: "Shipper",
        },
        ETA: {
            headerName: "ETA",
            field: "ETA",
        },
        ETI: {
            headerName: "ETI",
            field: "ETI",
        },
        TRIP_STATUS: {
            headerName: "Estatus del Viaje",
            field: "TripStatus",
        },
        EXCEPTION: {
            headerName: "Excepción",
            field: "Exception",
        },
        DESTINATION_CITY: {
            headerName: "Estacion de Destino",
            field: "DestinationCityState",
        },
        AI: {
            headerName: "Indicador de Actividad",
            field: "ActivityIndicator",
        },
        CONSIGNEE: {
            headerName: "Consignatario",
            field: "Consignee",
        },
        ROUTE: {
            headerName: "Ruta",
            field: "Route",
        },
        ONLINE_DEST: {
            headerName: "Destino en línea",
            field: "PlacementLocation",
        },
        PLACEMENT_AVAILABLE: {
            headerName: "Disponible",
            field: "AvailableForPlacement",
        },
        PLACEMENT_STATUS: {
            headerName: "Estatus de Situado",
            field: "PlacementStatus",
        },
        PLACEMENT_DATE: {
            headerName: "Fecha de Situado",
            field: "PlacementDate",
        },
        NET_TON: {
            headerName: "Ton Neta",
            field: "NetTons",
        },
        TARE_WEIGHT: {
            headerName: "Peso Tara",
            field: "TareWeight",
        },
        GROSS_WEIGHT: {
            headerName: "Peso Bruto",
            field: "GrossWeight",
        },
        OVER_WEIGHT: {
            headerName: "Sobrepeso",
            field: "OverweightStatus",
        },
        LOAD_LIMIT: {
            headerName: "Límite de Carga",
            field: "LoadLimit",
        },
        TOTAL_WEIGHT: {
            headerName: "Peso Total del Carro",
            field: "TotalWeightOnRail",
        },
        TRAIN_ID: {
            headerName: "ID de Tren",
            field: "TrainID",
        },
        PRODUCT_GROUP: {
            headerName: "Grupo de Producto",
            field: "ProductGroup",
        },
        CAR_LENGTH: {
            headerName: "Longitud de Carro",
            field: "CarLength",
        },
    },

    shipmentTypeLabels: {
        EN_ROUTE: "En Otro FFCC",
        INBOUND: "En Transito",
        ON_HAND: "En Industria",
        OUTBOUND: "Remitidos",
    },

    visibilityFilterOptions: {
        EQUIP_ID: {
            label: "Equipo",
            name: "equipment",
        },
        SHIPPER: {
            label: "Remitente",
            name: "shippers",
        },
        CAR_TYPES: {
            label: "Tipo Genérico de Equipo",
            name: "CarTypes",
        },
        EQUIP_KIND: {
            label: "Tipo Específico de Equipo",
            name: "EquipKind",
        },
        LOAD_STATUS: {
            label: "Estatus de Cargado",
            name: "loadStatus",
        },
        EVENT_CODES: {
            label: "Cod. Ultmo. Movm.",
            name: "eventCodes",
        },
        HAZARDOUS: {
            label: "Peligroso",
            name: "Hazardous",
        },
        OVER_WEIGHT: {
            label: "Sobrepeso",
            name: "OverweightStatus",
        },
        UNIT_CAR: {
            label: "Tren Unitario",
            name: "UnitCar",
        },
        ORIGIN: {
            label: "Origen",
            name: "Origin",
        },
        LOAD_LIMIT: {
            label: "Límite de Carga",
            name: "loadLimit",
        },
        BILLED: {
            label: "Documentado",
            name: "Billed",
        },
        EVENT_DATES: {
            label: "Fecha del último movimiento",
            name: "eventDates",
        },
        BAD_ORDER: {
            label: "Mal Orden",
            name: "BadOrder",
        },
        WITH_COMMENTS: {
            label: "Comentarios",
            name: "WithComments",
        },
        CONSIGNEE: {
            label: "Consignatario",
            name: "Consignee",
        },
        TOTAL_WEIGHT: {
            label: "Peso Total del Carro",
            name: "totalWeight",
        },
        SHIPPED_DATE: {
            label: "Fecha de Envío",
            name: "ShippedDate",
        },
        PLACEMENT_STATUS: {
            label: "Estatus de Situado",
            name: "PlacementStatus",
        },
        STORAGE: {
            label: "Almacenaje",
            name: "Storage",
        },
        ONHOLD: {
            label: "En espera",
            name: "OnHold",
        },
        DESTINATION: {
            label: "Destino",
            name: "Destination",
        },
        COMMODITY: {
            label: "Producto",
            name: "Commodity",
        },
        ETA: {
            label: "ETA",
            name: "Eta",
        },
        ETI: {
            label: "ETI",
            name: "Eti",
        },
        ACTIVITY_INDICATOR: {
            label: "Indicador de Actividad",
            name: "ActivityIndicator",
        },
        CARRIER: {
            label: "Ferrocarril",
            name: "Carrier",
        },
        PLACEMENT_AVAILABLE: {
            label: "Disponible",
            name: "PlacementAvailable",
        },
        CAR_KIND: {
            label: "Clase de Carro",
            name: "CarKind",
        },
        STCC: {
            label: "STCC",
            name: "Stcc",
        },
        EVENT_ROAD: {
            label: "Ferrocarril Actual",
            name: "eventRoad",
        },
        RAILROAD_DWELL_TIME: {
            label: "Tiempo de permanencia en el Ferrocarril",
            name: "RailroadDwellTime",
        },
        SHIPPER_DWELL_TIME: {
            label: "Tiempo de permanencia del Remitente",
            name: "ShipperDwellTime",
        },
        BLOCK_TO: {
            label: "Entregar A",
            name: "BlockTo",
        },
        NO_ETA: {
            label: "Sin ETA",
            name: "NoEta",
        },
        EXCEPTION: {
            label: "Excepción",
            name: "Exception",
        },
    },

    planningLbl: {
        Help_Me_Finding_Car_Types: "Ayuda para Encontrar Tipos de Carro",
        Which_Car_Type_Fits_Your_Needs: "Qué Tipo de Carro Necesito",
        Select_First_Number: "Selecciona el Primer Número",
        Select_the_Second_Number: "Selecciona el Segundo Número",
        Select_First_And_Second_Number: "Selecciona el Primer y Segundo Número",
        Now_Select_Third_Number: "Ahora Selecciona el Tercer Número",
        Select_the_Third_Number: "Selecciona el Tercer Número",
    },

    actionCodesNumbers: {
        detenido: "1",
        situar: "2",
        rechazar: "3",
        girar: "4",
        peso: "5",
        documentar: "6",
        fueradealmacenaje: "7",
        intraplanta: "8",
        mover: "9",
        liberardevacío: "10",
        "liberar&recargar": "11",
        liberarenelmismoestado: "12",
        malorden: "13",
    },

    reviewCarsColumns: [
        {
            headerName: "ID de Equipo",
            field: "equipmentID",
            maxWidth: 160,
            suppressMovable: true,
        },
        {
            headerName: "Estatus L/E",
            field: "leStatus",
            maxWidth: 130,
            suppressMovable: true,
        },
        {
            headerName: "Tipo de Carro Genérico",
            field: "carType",
            maxWidth: 130,
            suppressMovable: true,
        },
        {
            headerName: "Tipo de Carro Específico",
            field: "carKind",
            maxWidth: 120,
            suppressMovable: true,
        },
        {
            headerName: "Destino",
            field: "destination",
            maxWidth: 200,
            suppressMovable: true,
        },
        {
            headerName: "Estatus",
            field: "status",
            resizable: false,
            suppressMovable: true,
            minWidth: 85,
            maxWidth: 90,
            cellStyle: (params) => {
                let styles = {
                    borderRadius: "16px",
                    height: "32px",
                    top: "0px",
                    bottom: "0px",
                    margin: "auto",
                    lineHeight: "32px",
                    paddingRight: "0px",
                    paddingLeft: "0px",
                    textAlign: "center",
                }
                if (params.value === "Asignados") {
                    styles.backgroundColor = "#fec600"
                } else if (params.value === "Solicitados") {
                    styles.backgroundColor = "lightgrey"
                } else if (params.value === "Situados") {
                    styles.backgroundColor = "#7fae1b"
                }
                return styles
            },
        },
        {
            headerName: "Vía",
            field: "track",
            maxWidth: 180,
            suppressMovable: true,
        },
        {
            headerName: "Tren",
            field: "train",
            maxWidth: 180,
            suppressMovable: true,
        },
    ],

    viewsLbl: {
        views: "Vistas",
        savedView: "Vistas guardadas",
        manageView: "Administrar vistas",
        resetView: "Restablecer vistas",
        saveView: "Guardar vista",
        saveCurrentView: "Guardar vista actual",
        manageCurrentView: "Administrar vista actual",
        resetCurrentView: "Restablecer vista actual",
        saveViewSubTitle:
            "Guarde esta combinación de filtros, columnas, modos de vista y categorías de color.",
        saveNewView: "Guardar nueva vista",
        updateExistingView: "Actualizar la vista existente",
        makeThisMyDefaultView: "Hacer esta mi vista predeterminada",
        descriptionOptional: "Descripción (opcional)",
        saveChanges: "GUARDAR CAMBIOS",
        enterNameHere: "Ingrese nombre aquí",
        selectAView: "Seleccionar vista",
        applyView: "APLICAR VISTA",
        publicRailroad: "Público: Ferrocarril",
        publicCorporation: "Corporación Pública",
        viewManager: "Administrador de Vistas",
        viewManagerSubTitle: "Seleccione una vista para esta página",
        activeView: "Vista activa",
        none: "Ninguna",
        viewName: "Ver nombre",
        owner: "Propietario",
        description: "Descripción",
        default: "Predeterminado",
        actions: "Acciones",
        editView: "Editar vista",
        deleteView: "Eliminar vista",
        setAsDefault: "Establecido como Predeterminado",
        areYouSureYouWantToDelete: "Estas seguro que quieres borrarlo ",
        yesDeleteThisView: "Sí, eliminar esta vista",
        successfullyDeleted: "eliminado correctamente.",
        dismiss: "Descartar",
        successfullyUpdated: "actualizado correctamente.",
        previousDescriptionShownHere: "Descripción anterior mostrada aquí.",
        eta: "ETA",
        totalCars: "Total de Carros",
        view: "vista",
        successfullyCreated: "Creado exitosamente.",
        publicViewHelperText:
            "Nota: Las vistas publicas son visibles para su audiencia seleccionada. Solo el creador o los lideres autorizados pueden editarlas.",
        publicViewsLimitWarning:
            "Estas cerca del limite. Puedes tener hasta 10 vistas publicas.",
        publicViewsLimitError:
            "Has alcanzado el limite de vistas publicas. Puedes tener hasta 10 vistas publicas. Para agregar una nueva, convierte una vista existente en privada o elimina una.",
        publicViewsThresholdExceeded:
            "Las vistas publicas almacenadas superan el umbral utilizable de 10.",
        validationViewSave:
            "Ya existe una vista con este nombre. Por favor elija un nombre diferente.",
    },
    demurrage: {
        storage: "Almacenamiento",
        chargeManagement: "Administracion de cargos",
        demurrage: "Demora",
        pending: "Pendiente",
        invoiced: "Facturado",
        inDispute: "In Dispute",
        downloadCSV: "Exportar a CSV",
        searchOnAnyField: "Busqueda por cualquier campo",
        total: "Total",
        customer: "Cliente",
        accountingPeriod: "Período contable",
        serviceType: "Tipo de Servicio",
        calculation: "Calculo",
        holdType: "Tipo de Espera",
        transactionFrom: "Fechas transaccionales desde",
        transactionTo: "Fechas transaccionales a",
        railroad: "Ferrocarril",
        status: "Status",
        le: "L/E",
        ownerType: "Tipo de propietario",
        commodity: "Mercancia",
        cycleType: "Tipo de Ciclo",
        LE: "L/E",
        OWNER_TYPE: "Tipo de propietario",
        COMMODITY: "Mercancia",
        CYCLE_TYPE: "Tipo de Ciclo",
        CUST_ID: "ID del Cliente",
        SERVICE_TYPE: "Tipo de Servicio",
    },
    errorPage: {
        description:
            "Lo siento, pero no tienes permiso para acceder a esta página. Póngase en contacto con el administrador del sistema si cree que se trata de un error",
    },
    demurrageSummaryColumns: {
        DATE: {
            headerName: "Fecha",
            field: "Date",
        },
        CUST_ID: {
            headerName: "ID del Cliente",
            field: "CustomerId",
        },
        SERVICE_TYPE: {
            headerName: "Tipo de Servicio",
            field: "ServiceType",
        },
        HOLD_TYPE: {
            headerName: "Tipo de Espera",
            field: "HoldType",
        },
        INVOICE: {
            headerName: "Factura",
            field: "InvoiceNumber",
        },
        CALCULATION: {
            headerName: "Calculo",
            field: "CalculationType",
        },
        CARS: {
            headerName: "Carros",
            field: "TotalRailcars",
        },
        TOTAL_CHARGES: {
            headerName: "Monto",
            field: "TotalCharges",
        },
        STATUS: {
            headerName: "Estatus",
            field: "Status",
        },
    },

    holdTypeLabels: {
        OTHER: "Otros",
        STORAGE: "Almacenamiento",
        UNLOAD: "Descargando",
        LOAD: "Cargando",
    },

    calculationTypeLabels: {
        AVERAGE: "Promedio",
        SIMPLIFIED: "Simplificado",
        STRAIGHT: "Derecho",
        STORAGE: "Almacenamiento",
    },

    serviceTypeLabels: {
        DEMURRAGE: "Demora",
    },

    demurrageDetailsColumns: {
        LN: {
            headerName: "Ln",
            field: "",
        },
        EQUIPMENT_INFO: {
            headerName: "Equipo",
            field: "Railcar",
        },
        LE_STATUS: {
            headerName: "L/E",
            field: "DemurrageMoveType",
        },
        OWNER_TYPE: {
            headerName: "Tipo de propietario",
            field: "IsPrivateEquipment",
        },
        COMMODITY: {
            headerName: "Mercancia",
            field: "CommodityDescription",
        },
        INTO_STORAGE: {
            headerName: "En el almacenamiento",
            field: "IntoStorage",
        },
        BILL_START: {
            headerName: "Inicio de la factura",
            field: "BillStart",
        },
        BILL_END: {
            headerName: "Fin del proyecto de ley",
            field: "BillEnd",
        },
        CANCEL_DEBITS: {
            headerName: "Débitos cancelados",
            field: "CancelledDebits",
        },
        EARNED_CREDITS: {
            headerName: "Créditos ganados",
            field: "Earned Credits",
        },
        NON_CANCELLED_DEBITS: {
            headerName: "Adeudos no cancelados",
            field: "NonCancelledDebits",
        },
        CHARGEABLE_DEBITS: {
            headerName: "Días cargables/Débito",
            field: "ChargableDebits",
        },
        CONSTR_PLACE: {
            headerName: "Falta de Cupo",
            field: "ConstructivePlacementDate",
        },
        CONSTR_RELEASE: {
            headerName: "Liberado de Situado en Patio",
            field: "ReleaseFromConstructivePlacementDate",
        },
        ORDER: {
            headerName: "Orden",
            field: "OrderedDate",
        },
        PLACEMENT: {
            headerName: "Situado",
            field: "PlacementDate",
        },
        RELEASED: {
            headerName: "Liberado de Situado",
            field: "ReleasedDate",
        },
        CYCLE_TYPE: {
            headerName: "Tipo de Ciclo",
            field: "CycleType",
        },
        TOT_DAYS: {
            headerName: "Dias Totales",
            field: "DemurrageDays",
        },
        FREE_EXCL: {
            headerName: "Libre + Dias Excluidos",
            field: "CreditDays",
        },
        CHG_DAYS: {
            headerName: "Dias Facturables",
            field: "ChargeDays",
        },
        ACCRUED_CHARGES: {
            headerName: "Cargos Acumulados",
            field: "ChargeAmount",
        },
    },
    generalPlacementLabels: {
        generalPlacement: "Colocación General",
        latestServiceDate: "Ultima Fecha de Servicio",
        reqDate: "Fecha de Solicitud",
        status: "Estado",
        requestId: "ID de solicitud",
        serviceDate: "Fecha de Servicio",
        submitInfo: "Enviar Información",
        submittedBy: "Presentado Por",
        submittedDate: "Fecha Presentada",
        equipmentOverview: "Descripción de Equipo",
        newRequest: "Nueva solicitud",
        quantity: "Cant.",
        loadShortcut: "C",
        emptyShortcut: "V",
        submitRequest: "Enviar Solicitud",
        oldestEquipment: "Equipo mas Antiguo",
        newestEquipment: "Equipo mas Nuevo",
        largestBlock: "Lote mas Grande",
        easiestAvailable: "Facil Disponible",
        selectCriteriaPlacementRequest:
            "Seleccione los criterios para la solicitud de situado.",
        longDesc1:
            "Las solicitudes de situado  general son solicitudes de equipo consignado a sus instalaciones.",
        longDesc2: "Para suministrar equipos ferroviarios,",
        placeAcarOrder: "realice  un pedido de carros.",
        location: "Ubicacion",
        equipmentCharacteristics: "Caracteristicas del Equipo",
        commodityAndCarType: "Producto y Tipo de Carro",
        addtoRequest: "Agregar a la Solicitud",
        serviceTime: "Hora de Servicio",
        maxLength15: "Máximo 15 carácteres",
        specialNotAllowed: "Caracteres especiales no permitidos",
        maxLength25: "Máximo 25 carácteres",
        servicableDays: "Serviceable days only",
        noRailcarsAdded: "Ningunos Carro Añadidos",
        loadLimit: "Limite de Carga",
        weightOnRail: "Peso sobre el Riel",
        equipmentMark: "Marca de Equipo",
        carsForGP: "Carros para General Placment Solicitado",
    },

    requestPreference: {
        oldestEquipment: "Equipo mas Antiguo",
        newestEquipment: "Equipo mas Nuevo",
        largestBlock: "Lote mas Grande",
        easiestAvailable: "Facil Disponible",
    },

    reviewRequestsColumns: {
        QUANTITY: {
            headerName: "Cant.",
            field: "quantity",
        },
        LESTATUS: {
            headerName: "C/V",
            field: "leStatus",
        },
        CAR_TYPE: {
            headerName: "Tipo Genérico de Equipo",
            field: "carType",
        },
        CAR_KIND: {
            headerName: "Tipo Específico de Equipo",
            field: "carKind",
        },
        CAR_MARK: {
            headerName: "Marca de Equipo",
            field: "carMark",
        },
        TRACK: {
            headerName: "Vía",
            field: "trackId",
        },
        POSITION: {
            headerName: "Pos.",
            field: "trackPosition",
        },
        COMMODITY: {
            headerName: "Producto",
            field: "commodity",
        },
        STCC: {
            headerName: "STCC",
            field: "stcc",
        },
        RAILWT: {
            headerName: "Peso sobre el Riel (lbs)",
            field: "weightOnRail",
        },
        LOADLIMIT: {
            headerName: "Limite de Carga (lbs)",
            field: "loadLimit",
        },
        PREFERENCE: {
            headerName: "Preferencia",
            field: "requestPreference",
        },
        COMMENT: {
            headerName: "Comentarios",
            field: "comment",
        },
    },
    Email: {
        EmailNotifications: "Notificaciones de Correo Electrónico",
        carActions: "Acciones de carros",
        carOrders: "Pedidos de carros",
        generalPlacements: "Situados generales",
        modifyEmail: "Modificar lista de correo electrónico",
        saveEmails: "Guardar correos electrónicos",
        carOrderTooltip:
            "Se enviará una notificación de correo electrónico a todas las direcciones identificadas cuando se solicite un pedido de carro",
        generalPlacementTooltip:
            "Se enviará una notificación de correo electrónico a todas las direcciones identificadas cuando se solicite un situado general",
        switchRequestsTooltip:
            "Esto enviará un correo electrónico de notificación a las direcciones identificadas cuando se solicita una solicitud de cambio a través del menú de solicitud de cambio",
        carActionTooltip:
            "Se enviará una notificación de correo electrónico a todas las direcciones identificadas para las acciones realizadas en el inventario a través del panel de acciones",
        emailFormat:
            "*Los correos electrónicos deben tener el siguiente formato (primeroúltimo@email.com, primeroúltimo@email.com)",
    },
    switchRequestLabels: {
        switchRequestInfo: "INFORMACIÓN DE SOLICITUD DE CAMBIO",
        newSwitchRequest: "Nueva solicitud de cambio",
        switchRequestEntry: "Entrada de solicitud de cambio",
        station: "Estación",
        status: "Estatus",
        individualRequestingService: "Servicio de solicitud individual",
        requestCreated: "Solicitud creada",
        customer: "Cliente",
        shipperId: "Remitente",
        switchRequestPattern: "Patrón de solicitud de conmutación",
        serviceRequested: "Servicio solicitado",
        time: "Tiempo",
        switchRequests: "Solicitudes de cambio",
        patternUsed: "Patrón utilizado",
        dateRequested: "Fecha solicitada",
        switchRequestCreatedSuccessfully:
            "La solicitud se ha enviado correctamente.",
        switchRequestCreateFailed:
            "Si la solicitud falla, inténtelo de nuevo o comuníquese con su ferrocarril de servicio.",
        dateWanted: "Fecha Solicitada",
        switchRequestCreatedelayed:
            "La solicitud tarda más de lo esperado. Pedimos disculpas por las molestias.",
        cars: "Carros",
    },
    legalDisclaimerFooter: {
        privacyPolicy: "Política de Privacidad",
        termsAndConditions: "Términos y Condiciones",
        allRightsReserved: "Todos los derechos reservados.",
    },
    exceptionValues: {
        badOrder: "Mal orden",
        etaDelayed: "Tiempo Est. de Arribo con Demora",
        outOfRoute: "Fuera de ruta",
    },
}
